import { render, staticRenderFns } from "./AccessTokenAssign.vue?vue&type=template&id=b63cbe36"
import script from "./AccessTokenAssign.vue?vue&type=script&lang=js"
export * from "./AccessTokenAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports